import React, { Component } from 'react'

export default class Timeline extends Component {
    render() {
        return(
            <div>
                <section className="colorlib-experience" data-section="timeline">
                    <div className="colorlib-narrow-content">
                        <div className="row">
                            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                                <span className="heading-meta">Highlights</span>
                                <h2 className="colorlib-heading animate-box">Timeline</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="timeline-centered">
                                    <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-3">
                                                <i className="icon-pen2"/>
                                            </div>
                                            <div className="timeline-label">
                                                <h2>Freelance Web-Developer <span>2020-present</span></h2>
                                                <p>As a fresh graduate seeking for job opportunity, I have been developing websites during my free time as a hobby. Websites that I developed are mainly built using PHP, HTML/CSS, JavaScript, MYSQL</p>
                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-4">
                                                <i className="icon-pen2"/>
                                            </div>
                                            <div className="timeline-label">
                                                <h2>Undergraduate at University of Southampton <span>2017-2020</span></h2>
                                                <p>I am pursuing my undergraduate studies with major in Computer Science. Some mentionable courses I have taken includes Object Oriented Programming, Data Structure and Algorithm, Computer Systems, Cloud Computing</p>
                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-5">
                                                <i className="icon-pen2"/>
                                            </div>
                                            <div className="timeline-label">
                                                <h2>Foundations Student at Bellerbys College Brighton <span>2016-2017</span></h2>
                                                <p>I am taking Foundations course majoring in Engineering and Computer Science. Having completed the course, it helped me improve my understanding towards complex mathematical problems as well as building my confidence through presentations.</p>
                                            </div>
                                        </div>
                                    </article>
                                    <article className="timeline-entry-begin animate-box" data-animate-effect="fadeInBottom">
                                        <div className="timeline-entry-inner">
                                            <div className="timeline-icon color-none"></div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}